module.exports = __webpack_public_path__ + "img/selo-ra1000.b8eb88c.png";